"use client";

import Link from "next/link";
import type { MouseEvent } from "react";

export function CloseControls({
  closeHref,
  onClose,
}: {
  closeHref: string;
  onClose?: () => void;
}) {
  const handleClick = onClose
    ? (e: MouseEvent) => {
        e.preventDefault();
        onClose();
      }
    : undefined;

  return (
    <div className="flex items-center justify-between mb-4 -mt-1">
      <Link
        href={closeHref}
        className="inline-flex items-center gap-1.5 cs-mono text-[12px] uppercase tracking-[0.14em] text-ink-3 hover:text-ink"
        scroll={false}
        onClick={handleClick}
      >
        <span aria-hidden>←</span>
        <span>Back to list</span>
      </Link>
      <Link
        href={closeHref}
        aria-label="Close hearing detail"
        className="inline-flex items-center justify-center w-8 h-8 rounded-full text-ink-3 hover:bg-bg-2 hover:text-ink transition-colors"
        scroll={false}
        onClick={handleClick}
      >
        <svg
          aria-hidden="true"
          viewBox="0 0 16 16"
          width="13"
          height="13"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
        >
          <path d="M3 3l10 10M13 3L3 13" />
        </svg>
      </Link>
    </div>
  );
}
